<!-- <div class="breadcrumb-sm">
    <div class="container">
        <ol class="cd-breadcrumb">
			<li><a [routerLink]="['/']">Home</a></li>
			<li class="current"><em>Academic Phrasebank</em></li>
		</ol>
    </div>
</div> -->

<!-- <div class="top-tools-tab-mobile" id="tabs-tools" role="tablist">
    <a [routerLink]="['/grammar-checker']" role="tab" aria-selected="false" tabindex="-1" id="tab-grammar">
        <img src="assets/images/menu-icons/grammar-checker.svg" alt="grammar-checker">
        <p>Grammar Checker</p>
    </a>
    <a [routerLink]="['/paraphrasing-tool']" role="tab" aria-selected="false" tabindex="-1" id="tab-paraphraser">
        <img src="assets/images/menu-icons/pharaphraser.svg" alt="Paraphraser">
        <p>Paraphraser</p>
    </a>
    <a [routerLink]="['/journal-finder']" role="tab" aria-selected="true" tabindex="0" id="tab-jorunal-finder">
        <img src="assets/images/menu-icons/journal-finder.svg" alt="Journal Finder">
        <p>Journal Finder</p>
    </a>
    <a [routerLink]="['/ai-content-detector']" role="tab" aria-selected="false" tabindex="-1" id="tab-ai-detector">
        <img src="assets/images/menu-icons/ai-detector.svg" alt="AI Detector">
        <p>AI Detector</p>
    </a>
    <a [routerLink]="['/academic-phrasebank']" role="tab" aria-selected="true" class="active" tabindex="0" id="tab-phrasebank">
        <img src="assets/images/menu-icons/phrasebank.svg" alt="Academic Phrasebank">
        <p>Academic Phrasebank</p>
    </a>
</div> -->


<div class="trinka_cloud_wrap" #target>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinkaアカデミックフレーズバンク</h1>
                        <p>最適な学術的フレーズや言い回しの代替案を提案します
                        </p>

                        <div class="contact" id="phasebankEmailBox">
                            <form class="form-inline" [formGroup]="phaseBankSearchForm" (ngSubmit)="phaseBankSearch()">
                                <div class="form-group ">

                                    <input placeholder="似た意味のフレーズを見つけたいフレーズを貼り付け／入力してください" formControlName="sentence" class="form-control" name="email">
                                </div>
                                <button type="submit" id="phasebank" class="btn btn-primary mb-2">検索</button>
                            </form>
                        </div>
                        <p class="phasebanknote">例： "This represents an important topic to study because"</p>
                        <div class="purplephasebank">
                            <a [routerLink]="['/academic-phrasebank-browse', 'topic', 'subtopic']"><h2>論文セクション別のフレーズ一覧はこちら</h2></a>
                        </div>
                        <div class="disclaimercontents">
                            <p>本フレーズバンクの情報の学術目的での利用は無料です。商用利用の場合は、<a href="mailto:sales&#64;trinka&#46;ai">お問い合わせ</a>ください。 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd-sm section-purple list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <!-- <img src="assets/images/brain.png" alt="brain" srcset=""> -->
                        <h3>AIによる<br/>瞬時の提案</h3>
                        <p>
                            TrinkaのAIモデルが適切な表現を瞬時に提案。学術英語のライティングに掛かる時間の短縮につながります。
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <!-- <img src="assets/images/network.png" alt="brain" srcset=""> -->
                        <h3>大規模な<br/>学術データベース</h3>
                        <p>Trinkaのアカデミックフレーズバンクは、膨大な数の学術刊行物から学習。アカデミックで明確な英語表現を提案します。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <!-- <img src="assets/images/snap.png" alt="brain" srcset=""> -->
                        <h3>優れた<br/>検索性</h3>
                        <p>AIがユーザーの意図を読み取り、文脈に合わせた適切なアカデミックフレーズを探し出し提案します。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="assets/images/brain.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>AI to Find the Right Phrase</h3>
                            <p>
                                Our specially trained AI model saves you time finding the right phrase to write confidently from our large
                                <b>academic phrasebank</b>
                                in just seconds.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="assets/images/network.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>Large Academic Database</h3>
                            <p>
                                Our
                                <b>academic phrasebank</b> curates phrases from millions of academic publications to help you
                                easily express your intent while meeting academic conventions. </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="features_cards">
                        <img src="assets/images/snap.png" alt="brain" srcset="">
                        <div class="features_cards_inner">
                            <h3>Easy to Search and Use</h3>
                            <p>Save time and write confidently using our
                                <b>academic phrasebank</b> powered by AI technology that makes finding the right phrases quick
                                and easy.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->


</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h2 class="h2-tag">Trinkaアカデミックフレーズバンクについて</h2>
                    <p>Trinka（トリンカ）アカデミックフレーズバンクは、英語のフレーズ・文の大規模データベースで、学術的なスタイル・規範に則った適切な表現を見つけられるものです。</p>
                    <p>Trinkaアカデミックフレーズバンクは、科学雑誌に掲載された論文を始めとした学術的な刊行物に含まれるフレーズ／文の大規模コーパスで、専門の研究者と編集者・校正者のチームがキュレーションを行っています。</p>
                    <p>自社開発のAI技術によって関連性の高い結果を表示し、学術英語の執筆時間節約にお使いいただけます。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="assets/images/safe-secure.webp" alt="safe" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h2 class="h2-tag">Trinkaアカデミックフレーズバンクの使い方</h2>

                        <p>Trinkaアカデミックフレーズバンクでの、フレーズの探し方は２通りです。</p>
                        <p class="purple_bullet">
                            <b>類似フレーズの検索：</b>
                            フレーズ、表現を検索窓に入力または貼り付けて検索を実行するとAIが内容を理解し、類似するフレーズが一覧表示されます。選んだフレーズは、ワンクリックでクリップボードにコピーできます。
                        </p>
                        <p class="purple_bullet">
                            <b>論文セクションごとの用例一覧からの選択：</b> 例えば、序論で先行研究を紹介し、テーマの重要性を伝える上で適切なフレーズを探には、「論文セクション別のフレーズ一覧」より「Introducing Work」の中の「Establishing the importance of the topic」をクリックします。選択した項目にかかわるフレーズが一覧表示されますので、ふさわしい候補をワンクリックでクリップボードにコピーできます。
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                        <img src="assets/images/academicPhraseBank.webp" alt="academic phrase bank" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="softWare_workFlow cloud_key_features">
    <div class="trinka_container">
        <div class="row">
            <!-- <div class="col-md-12">

            </div> -->
            <div class="col-md-12">
                <div class="trinka-title text-center">
                    <h2>Trinkaのアカデミックフレーズバンクとマンチェスター大学のAcademic Phrasebank</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>ジョン・モーリー博士によるマンチェスター（The University of Manchester）Academic Phrasebankは、マンチェスター学術フレーズバンクはウェブサイト版、およびPDFファイルのダウンロード版で利用可能な文例・フレーズ集で、世界中の研究者たちが、英語学術論文の構文やフレーズを調べる際に使用しています。</p>
                    <p>TrinkaのアカデミックフレーズバンクはAI技術を活用した簡単な検索と、論文セクションごとの一覧から関連するフレーズを容易に見つけられるようにするものです。
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>世界で使われるAIツール</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaは、世界中の研究者に、論文執筆と出版準備のための英文校正ツールとしてご利用いただいています。文法修正に加え、各種チェックツールやレポートで、よりスムーズな論文の執筆・投稿プロセスをサポートします。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" rel="noopener noreferrer" class="filled-btn">今すぐ試す</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="faqQuestionAnwser section-pd " #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>アカデミックフレーズバンクに関するよくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        <h2>アカデミックフレーズバンクは、どのように役立ちますか？   </h2> 
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>学術論文の執筆は、文法的に正確な英語であるだけでなく、学術的な慣行に従った言い回しを使う必要があります。Trinkaのアカデミックフレーズバンクを使えば、ご自身で他の論文から最適なフレーズを探すのではなく、学術出版物で使われるフレーズが一覧表示されるため、効率的な執筆につながります。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent"><h2>Trinkaのアカデミックフレーズバンクは有料ですか？</h2></a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaのアカデミックフレーズバンクは、無料でご利用いただけます。制限はありません。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        <h2>アカデミックフレーズバンクのフレーズを使用することは、剽窃とみなされますか？</h2>
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaのアカデミックフレーズバンクからフレーズを使用する際は、そのフレーズの骨格にご自身の研究成果などを落とし込むことで、オリジナルの文章にしてください。これにより、盗用・剽窃とみなされない英文執筆が可能になります。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        <h2>Trinkaのアカデミックフレーズバンクは、どの分野で使用できますか？</h2>
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaのアカデミックフレーズバンクには、あらゆる学術領域の膨大な数の論文・刊行物のデータベースから抽出されたフレーズ・文例が収録されています。分野に関わらずご活用いただけます。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/ingGxMsQgdI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>
